export default [
  {
    icon: 'mdi-bookmark-outline',
    name: 'Club rebelde',
    beforeEnter: (to, from, next) => {
      window.location.href = '/v2/club-rebelde';
    },
    path: '/club-rebelde',
    component: () => import(/* webpackChunkName: "opendata" */ '@/views/RouterViewComponent'),
    redirect: '/club-rebelde/main',
    id: 'opendata-toolbar',

    meta: {
      requiresAuth: true,
      allowedRoles: [
        'lopd',
        'consultant',
        'admin',
        'superadmin',
        'pyme',
        'autonomous',
        'employees',
      ],
      toolbar: true,
      tooltip: null,
    },
    children: [
      {
        name: 'Espacio Club Rebelde',
        icon: 'mdi-bookmark-outline',
        path: '/club-rebelde/main',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/club-rebelde';
        },
        component: () => import(/* webpackChunkName: "club-rebelde-main" */ './views/ClubRebelde'),
        meta: {
          requiresAuth: true,
          allowedRoles: [
            'lopd',
            'consultant',
            'admin',
            'superadmin',
            'pyme',
            'autonomous',
            'employees',
          ],
          drawer: true,
          tooltip: null,
        },
      },
      {
        name: 'Club rebelde - Swipcar',
        icon: 'mdi-car-outline',
        path: '/club-rebelde/swipcar',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/club-rebelde';
        },
        component: () =>
          import(/* webpackChunkName: "club-rebelde-swipcar" */ './views/ClubRebeldePartner'),
        meta: {
          requiresAuth: true,
          allowedRoles: [
            'lopd',
            'consultant',
            'admin',
            'superadmin',
            'pyme',
            'autonomous',
            'employees',
          ],
          drawer: true,
          tooltip: null,
          alias: 'swipcar',
          title: 'Swipcar',
        },
      },
      {
        name: 'Club rebelde - Capital On Tap',
        icon: 'mdi-credit-card-check-outline',
        path: '/club-rebelde/capital-on-tap',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/club-rebelde';
        },
        component: () =>
          import(/* webpackChunkName: "club-rebelde-capital-on-tap" */ './views/ClubRebeldePartner'),
        meta: {
          requiresAuth: true,
          allowedRoles: [
            'lopd',
            'consultant',
            'admin',
            'superadmin',
            'pyme',
            'autonomous',
            'employees',
          ],
          drawer: true,
          tooltip: null,
          alias: 'capital-on-tap',
          title: 'Capital On Tap',
        },
      },
      {
        name: 'Club rebelde - SingularCover',
        icon: 'mdi-folder-multiple-plus-outline',
        path: '/club-rebelde/singularcover',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/club-rebelde';
        },
        component: () =>
          import(/* webpackChunkName: "club-rebelde-singularcover" */ './views/ClubRebeldePartner'),
        meta: {
          requiresAuth: true,
          allowedRoles: [
            'lopd',
            'consultant',
            'admin',
            'superadmin',
            'pyme',
            'autonomous',
            'employees',
          ],
          drawer: true,
          tooltip: null,
          alias: 'singularcover',
          title: 'SingularCover',
        },
      },
      {
        name: 'Club rebelde - Ideados Formación',
        icon: 'mdi-book-open-variant',
        path: '/club-rebelde/ideados',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/club-rebelde';
        },
        component: () =>
          import(/* webpackChunkName: "club-rebelde-ideados-formacion" */ './views/ClubRebeldePartner'),
        meta: {
          requiresAuth: true,
          allowedRoles: [
            'lopd',
            'consultant',
            'admin',
            'superadmin',
            'pyme',
            'autonomous',
            'employees',
          ],
          drawer: true,
          tooltip: null,
          alias: 'ideados',
          title: 'Ideados Formación',
        },
      },
      {
        name: 'Club rebelde - Grupo MPE',
        icon: 'mdi-account-hard-hat',
        path: '/club-rebelde/grupo-mpe',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/club-rebelde';
        },
        component: () =>
          import(/* webpackChunkName: "club-rebelde-valora-prevencion" */ './views/ClubRebeldePartner'),
        meta: {
          requiresAuth: true,
          allowedRoles: [
            'lopd',
            'consultant',
            'admin',
            'superadmin',
            'pyme',
            'autonomous',
            'employees',
          ],
          drawer: true,
          tooltip: null,
          alias: 'grupo-mpe',
          title: 'grupo-mpe',
        },
      },
      {
        name: 'Club rebelde - Circulantis',
        icon: 'mdi-account-cash-outline',
        path: '/club-rebelde/circulantis',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/club-rebelde';
        },
        component: () =>
          import(/* webpackChunkName: "club-rebelde-circulantis" */ './views/ClubRebeldePartner'),
        meta: {
          requiresAuth: true,
          allowedRoles: [
            'lopd',
            'consultant',
            'admin',
            'superadmin',
            'pyme',
            'autonomous',
            'employees',
          ],
          drawer: true,
          tooltip: null,
          alias: 'circulantis',
          title: 'Circulantis',
        },
      },
      {
        name: 'Club rebelde - Gana Energía',
        icon: 'mdi-lightbulb-on-outline',
        path: '/club-rebelde/gana-energia',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/club-rebelde';
        },
        component: () =>
          import(/* webpackChunkName: "club-rebelde-gana-energia" */ './views/ClubRebeldePartner'),
        meta: {
          requiresAuth: true,
          allowedRoles: [
            'lopd',
            'consultant',
            'admin',
            'superadmin',
            'pyme',
            'autonomous',
            'employees',
          ],
          drawer: true,
          tooltip: null,
          alias: 'gana-energia',
          title: 'Gana Energía',
        },
      },
      {
        name: 'Club rebelde - Bulldoc',
        icon: 'mdi-file-document-multiple-outline',
        path: '/club-rebelde/bulldoc',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/club-rebelde';
        },
        component: () =>
          import(/* webpackChunkName: "club-rebelde-mil-contratos" */ './views/ClubRebeldePartner'),
        meta: {
          requiresAuth: true,
          allowedRoles: [
            'lopd',
            'consultant',
            'admin',
            'superadmin',
            'pyme',
            'autonomous',
            'employees',
          ],
          drawer: true,
          tooltip: null,
          alias: 'bulldoc',
          title: 'Bulldoc',
        },
      },
      // {
      //   name: 'Club rebelde - Mil Contratos',
      //   icon: 'mdi-file-document-multiple',
      //   path: '/club-rebelde/milcontratos',
      //   component: () =>
      //     import(/* webpackChunkName: "club-rebelde-mil-contratos" */ './views/ClubRebeldePartner'),
      //   meta: {
      //     requiresAuth: true,
      //     allowedRoles: [
      //       'lopd',
      //       'consultant',
      //       'admin',
      //       'superadmin',
      //       'pyme',
      //       'autonomous',
      //       'employees',
      //     ],
      //     drawer: true,
      //     tooltip: null,
      //     alias: 'milcontratos',
      //     title: 'MilContratos',
      //   },
      // },
    ],
  },
];
